import*as t from"react";let e=(0,t.createContext)(void 0);export{e as AuthContext};
//# sourceMappingURL=context.js.map